/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    "use strict";

    /**
     * Colors Section of WalkIn Manager Settings
     */
    export class ColorsSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {
    }

}